import { render, staticRenderFns } from "./UserSettingsContainer.vue?vue&type=template&id=dacd9220&"
import script from "./UserSettingsContainer.vue?vue&type=script&lang=js&"
export * from "./UserSettingsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports